export const GET_CONVERSION_LOG_STICKY_COLUMNS = "GET_CONVERSION_LOG_PROFILE_STICKY_COLUMNS";
export const GET_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS = "GET_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS";
export const GET_CONVERSION_LOG_STICKY_COLUMNS_ERROR = "GET_CONVERSION_LOG_STICKY_COLUMNS_ERROR";

export const UPDATE_CONVERSION_LOG_STICKY_COLUMNS = "UPDATE_CONVERSION_LOG_STICKY_COLUMNS";
export const UPDATE_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS = "UPDATE_CONVERSION_LOG_STICKY_COLUMNS_SUCCESS";
export const UPDATE_CONVERSION_LOG_STICKY_COLUMNS_ERROR = "UPDATE_CONVERSION_LOG_STICKY_COLUMNS_ERROR";